module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./XYChart.js"));
	}, "XYChart");
}